// Ajax solr

$(function () {
	'use strict';
	const RESULTS_SELECTOR = '.js-results';
	const PLUGIN_SELECTOR = '.tx_solr';
	const LOADING_CLASS = 'is-loading';

	var ajaxifyUrl = function(url, type, record) {
		var glue = url.indexOf('?') === -1 ? '?' : '&';
		return url + glue + 'type=' + type + '&record=' + record;
	};

	var search = function(url, data, $target, pushHistory = true) {
		$target.addClass(LOADING_CLASS);
		$('html').removeClass('facets-popup-open');

		var onBeforeSend = pushHistory ? function (jqXHR, settings) {
			try {
				var pushUrl = new URL(settings.url, window.location.origin);
				var params = new URLSearchParams(pushUrl.search);
				params.delete('type');
				params.delete('record');
				pushUrl.search = params.toString();
				history.pushState({url: url, data: data}, null, pushUrl.toString());
			} catch (e) {
				// Ignore
			}
		} : $.noop;

		// Update filter and list view
		$.ajax({
			url: url,
			data: data,
			beforeSend: onBeforeSend,
			success: function (response) {
				var $response = $(response);
				$target.removeClass(LOADING_CLASS);
				$target.find('.js-facets-canton').html(
					$response.find('.js-facets-canton').html()
				);
				$target.find('.js-facets-areafacet').html(
					$response.find('.js-facets-areafacet').html()
				);
				$target.find('.js-facets-resultTag').html(
					$response.find('.js-facets-resultTag').html()
				);
				$target.find('.js-facets-canton-mobile').html(
					$response.find('.js-facets-canton-mobile').html()
				);
				$target.find('.js-facets-areafacet-mobile').html(
					$response.find('.js-facets-areafacet-mobile').html()
				);
				$target.find('.js-results').html(
					($response.find('.js-results').html() ? $response.find('.js-results').html() : "")
				);
				$target.find('.js-results-counter').html(
					$response.find('.js-results-counter').html()
				);
				$target.find('.js-results-counter-mobile').html(
					$response.find('.js-results-counter-mobile').html()
				);
				$target.find('.js-hidden-fields').html(
					$response.find('.js-hidden-fields').html()
				);
				$target.find('.js-hidden-fields-mobile').html(
					$response.find('.js-hidden-fields-mobile').html()
				);
				$target.find('.js-hidden-fields-input').html(
					$response.find('.js-hidden-fields-input').html()
				);
			}
		});
	};

	$(PLUGIN_SELECTOR).on('submit', '.js-jobportal-search form', function (event) {
		event.preventDefault();
		var $form = $(this);
		var $target = $form.closest(PLUGIN_SELECTOR);
		var type =  $form.closest('[data-type]').data('type');
		var record =  $form.closest('[data-record]').data('record');
		var data = $form.serializeArray();
		data.push({name: 'type', value: type});
		data.push({name: 'record', value: record});
		search($form.attr('action'), data, $target);
	});


	$(PLUGIN_SELECTOR).on('click change', '.js-facets [data-href]', function (event) {
		event.preventDefault();
		$('html').removeClass('facets-popup-open');
		var $el = $(this);
		var $target = $el.closest(PLUGIN_SELECTOR);
		var type =  $el.closest('[data-type]').data('type');
		var record =  $el.closest('[data-record]').data('record');
		var data = [];
		data.push({name: 'type', value: type});
		data.push({name: 'record', value: record});
		search($el.data('href'), data, $target);
	});

	var sliderMin = $(PLUGIN_SELECTOR).find('#fromPensum-search').val();
	var sliderMax = $(PLUGIN_SELECTOR).find('#toPensum-search').val();

	var slider1 = (function (){
		var pensumSliderSearch = document.getElementById('pensumSlider-search');
		noUiSlider.create(pensumSliderSearch, {
			start: [sliderMin, sliderMax],
			step: 10,
			connect: true,
			range: {
				'min': 0,
				'max': 100
			},
			format: {
				// 'to' the formatted value. Receives a number.
				to: function (value) {
					return value;
				},
				// 'from' the formatted value.
				// Receives a string, should return a number.
				from: function (value) {
					return Number(value.replace(',-', ''));
				}
			}
		});

		var fromPensumSearch = document.getElementById('fromPensum-search');
		var fromPensumValueSearch = document.getElementById('fromPensum-value-search');
		var toPensumSearch = document.getElementById('toPensum-search');
		var toPensumValueSearch = document.getElementById('toPensum-value-search');

		pensumSliderSearch.noUiSlider.on('update', function (values, handle) {

			var value = values[handle];

			if (handle) {
				toPensumSearch.value = value;
				toPensumValueSearch.innerHTML = value;

			} else {
				fromPensumSearch.value = value;
				fromPensumValueSearch.innerHTML = value;
			}
		});

		pensumSliderSearch.noUiSlider.on('change', function () {
			$('.jobportal--filter-box-pensum form').submit();
		});

		fromPensumSearch.addEventListener('change', function () {
			pensumSliderSearch.noUiSlider.set([this.value, null]);
		});

		toPensumSearch.addEventListener('change', function () {
			pensumSliderSearch.noUiSlider.set([null, this.value]);
		});

		return pensumSliderSearch;
	})();

	var slider2 = (function (){
		var pensumSliderSearch = document.getElementById('pensumSlider-search-mobile');
		noUiSlider.create(pensumSliderSearch, {
			start: [sliderMin, sliderMax],
			step: 10,
			connect: true,
			range: {
				'min': 0,
				'max': 100
			},
			format: {
				// 'to' the formatted value. Receives a number.
				to: function (value) {
					return value;
				},
				// 'from' the formatted value.
				// Receives a string, should return a number.
				from: function (value) {
					return Number(value.replace(',-', ''));
				}
			}
		});

		var fromPensumSearch = document.getElementById('fromPensum-search-mobile');
		var fromPensumValueSearch = document.getElementById('fromPensum-value-search-mobile');
		var toPensumSearch = document.getElementById('toPensum-search-mobile');
		var toPensumValueSearch = document.getElementById('toPensum-value-search-mobile');

		pensumSliderSearch.noUiSlider.on('update', function (values, handle) {

			var value = values[handle];

			if (handle) {
				toPensumSearch.value = value;
				toPensumValueSearch.innerHTML = value;
			} else {
				fromPensumSearch.value = value;
				fromPensumValueSearch.innerHTML = value;
			}
		});

		fromPensumSearch.addEventListener('change', function () {
			pensumSliderSearch.noUiSlider.set([this.value, null]);
		});

		toPensumSearch.addEventListener('change', function () {
			pensumSliderSearch.noUiSlider.set([null, this.value]);
		});

		return pensumSliderSearch;
	})();

	function initSliders() {
		var min = $(PLUGIN_SELECTOR).find('#fromPensum-search').val();//.attr('value');
		var max = $(PLUGIN_SELECTOR).find('#toPensum-search').val();//.attr('value');

		if (min) {
			slider1.noUiSlider.set([min, null]);
			slider2.noUiSlider.set([min, null]);
		}
		if (max) {
			slider1.noUiSlider.set([null, max]);
			slider2.noUiSlider.set([null, max]);
		}
	}

	window.addEventListener('popstate', function(e) {
		if (e.state) {
			search(e.state.url, e.state.data, $(PLUGIN_SELECTOR), false);
			$.each(e.state.data, function (i, value){
				console.log(value);

				$('[name="'+value.name+'"]').val(value.value);
			});
			initSliders();
		}
	});
});